(function () {
  var mobileQuery = window.matchMedia('(max-width: 767px)');
  var wrapperSelector = [
    '.product_button',
    '.product_custom_liquid',
    '.yv-product-quantity',
    '.product-option-selector'
  ].join(', ');
  var scheduled = false;
  var observedDetails = new WeakSet();
  var layoutObserver = new MutationObserver(scheduleUpdate);

  function relocateStockCounter(productDetail) {
    productDetail.querySelectorAll('.heymerch-stockcount-container').forEach(function (stockCounter) {
      var actionContainer =
        stockCounter.closest('.pdp-action-container') || productDetail.querySelector('.pdp-action-container');
      var stockMessage = stockCounter.querySelector('.heymerch-stockcount-wrapper-stock');
      var scarcityEnabled =
        actionContainer && !actionContainer.classList.contains('scarcity-widget-disabled');
      var hasStockMessage =
        scarcityEnabled && stockMessage && stockMessage.textContent.trim() !== '';

      stockCounter.classList.toggle('product-stock-alert--active', Boolean(hasStockMessage));
      stockCounter.classList.toggle('product-stock-alert--empty', !hasStockMessage);

      if (actionContainer) {
        actionContainer.classList.toggle('stock-alert-enabled', Boolean(hasStockMessage));
        if (stockCounter.parentNode !== actionContainer || stockCounter !== actionContainer.firstElementChild) {
          actionContainer.insertBefore(stockCounter, actionContainer.firstChild);
        }
      }
    });
  }

  function updateWrapper(wrapper) {
    if (!mobileQuery.matches) {
      wrapper.classList.remove('product-layout-empty');
      return;
    }

    var isEmpty = wrapper.getBoundingClientRect().height <= 1;
    wrapper.classList.toggle('product-layout-empty', isEmpty);
  }

  function updateLayout() {
    scheduled = false;
    document.querySelectorAll('.yv-main-product-detail').forEach(function (productDetail) {
      if (!observedDetails.has(productDetail)) {
        layoutObserver.observe(productDetail, {
          attributes: true,
          attributeFilter: ['class', 'hidden', 'style'],
          childList: true,
          subtree: true
        });
        observedDetails.add(productDetail);
      }
      relocateStockCounter(productDetail);
      productDetail.querySelectorAll(wrapperSelector).forEach(updateWrapper);
    });
  }

  function scheduleUpdate() {
    if (scheduled) {
      return;
    }

    scheduled = true;
    window.requestAnimationFrame(updateLayout);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleUpdate, { once: true });
  } else {
    scheduleUpdate();
  }

  if (mobileQuery.addEventListener) {
    mobileQuery.addEventListener('change', scheduleUpdate);
  } else {
    mobileQuery.addListener(scheduleUpdate);
  }

  window.addEventListener('resize', scheduleUpdate);
})();
